import { UiModalDeclarationService } from './modal.declaration.service';
import { uiModalDeclarationComponent } from './modal.declaration.component';
import { uiModalComponent } from './modal.component';
import { uiModalTriggerDirective } from './modal.trigger.directive';

export default angular
  .module('ng1-modal', [])
  .service('uiModalDeclarationService', UiModalDeclarationService)
  .component('uiModalDeclaration', uiModalDeclarationComponent)
  .component('uiModal', uiModalComponent)
  .directive('uiModalTrigger', uiModalTriggerDirective)
  .name;
